import { blue, lightBlue, grey } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

export default createTheme({
  palette: {
    primary: blue,
    secondary: {
      main: lightBlue[400],
      contrastText: '#fff',
    },
    grey,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { height: '100vh', background: grey[100] },
        '#root': { height: '100%' },
      },
    },
    MuiModal: {
      defaultProps: {
        disableRestoreFocus: import.meta.env.DEV,
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          backgroundColor: grey[900],
          '&:hover': {
            backgroundColor: blue[800],
          },
        },
      },
    },
  },
})
